import React from "react";

export const Page404 = () => {
    return (
        <section className="hero-section">
            <div className="container">
                <div className="left-col">
                    <h1>Error 404</h1>
                    <p>The page you requested was not found</p>
                </div>
            </div>
        </section>
    );
};
